import { KeyboardEvent as ReactKeyboardEvent } from 'react';
import { KeyboardSensor, KeyboardSensorOptions } from '@dnd-kit/core';

const INTERACTIVE_SELECTOR =
  'input, textarea, select, button, a, [contenteditable="true"]';

export class ColumnReorderKeyboardSensor extends KeyboardSensor {
  static activators = [
    {
      eventName: 'onKeyDown' as const,
      handler: (
        event: ReactKeyboardEvent,
        options: KeyboardSensorOptions,
        context: Parameters<(typeof KeyboardSensor.activators)[0]['handler']>[2]
      ) => {
        if (
          (event.target as HTMLElement | null)?.closest?.(INTERACTIVE_SELECTOR)
        )
          return false;

        return KeyboardSensor.activators[0].handler(event, options, context);
      },
    },
  ];
}
